import {Button, Col, DatePicker, Form, Input, InputNumber, Row, Select} from 'antd';
import React from 'react';
import EditFormComponent from '../common/EditFormComponent';
import {Arguments} from '../common/Arguments';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const DetailPartyActivity = () => {
	const apiList = [Arguments.host + '/society_organization/base/branch/api!addPartyActivity.do'];

	return (
		<EditFormComponent UserForm={PartyActivityForm} url={apiList}/>
	);
};

const PartyActivityForm = ({onFinish, initialValues}) => {
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			initialValues={initialValues}
			style={{maxWidth: 1200, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityName" label="活动主题" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="activityDate" label="活动时间" rules={[{required: true, message: '内容不能为空'}]}>
						<DatePicker placeholder="选择日期" disabled={true}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="activityScope" label="参加人数" rules={[{required: true, message: '内容不能为空'}]}
							   initialValue={0}>
						<InputNumber min={0} style={{width: 150}} disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityAddress" label="活动地址" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityForm" label="活动形式" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="activityApplyMoney" label="申请经费">
						<Input disabled={true}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="activityApprovalMoney" label="审批经费">
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item name="checkStatus" label="审核状态" rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="未审">
						<Select>
							<Select.Option value="通过">通过</Select.Option>
							<Select.Option value="驳回">驳回</Select.Option>
							<Select.Option value="未审">未审</Select.Option>
						</Select>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="activityCompere" label="主持人"
							   rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="activityMemo" label="活动说明" rules={[{required: true, message: '内容不能为空'}]}>
						<div style={{marginTop: 4}} dangerouslySetInnerHTML={{__html: initialValues.activityMemo}}/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<Button
					type="primary"
					htmlType="button"
					onClick={() => {
						window.history.back();
					}}
				>
					返回
				</Button>
			</Form.Item>
		</Form>
	);
};

export default DetailPartyActivity;
